const LEGEND_ITEM_LEFT_PADDING = 8;
const LEGEND_ITEM_RIGHT_PADDING = 16;
const LEGEND_ITEM_GAP = 8;

export { LEGEND_ITEM_GAP, LEGEND_ITEM_LEFT_PADDING, LEGEND_ITEM_RIGHT_PADDING };
